
import React, { ReactNode } from "react";
interface TabActionProps {
  children: ReactNode;
}

const TabAction: React.FC<TabActionProps> = ({ children }) => {
  return <div className="h-10 bg-black  bg-opacity-50  flex justify-end items-center px-4"> {children}</div>;
};

export default TabAction;
